import local from "@/utils/local";

// 设置注册步骤
export const SET_SIGN_UP_SETP = (state, step) => {
  state.signUpStep = step;
};

// 设置用户登录信息
export const SET_USER_LOGIN_INFO = (state, data) => {
  state.userInfo = data;
};
//将token保存到sessionStorage里，token表示登录状态
export const SET_TOKEN = (state, data) => {
  state.token = data;
  window.sessionStorage.setItem("token", data);
};

//将token保存到sessionStorage里，token表示登录状态
export const SET_POT_TOKEN = (state, data) => {
  state.potToken = data;
  window.sessionStorage.setItem("potToken", data);
};


// 设置加载状态
export const SET_LOAD_STATUS = (state, status) => {
  state.isLoading = status;
};

// 设置秒杀商品
export const SET_SECKILLS_INFO = (state, seckills) => {
  state.seckills.goodsList = seckills[0];
  state.seckills.deadline = seckills[1];
};

// 设置轮播(营销)图
export const SET_CAROUSELITEMS_INFO = (state, {
  carouselItems,
  activity
}) => {
  state.marketing.CarouselItems = carouselItems;
  state.marketing.activity = activity;
};
// 设置每周特价商品
export const SET_WEEKLY_SPECIAL_INFO = (state, weeklyList) => {
  state.weekSpecial.specialList = weeklyList[0];
  state.weekSpecial.weeklyDeadline = weeklyList[1];
  // state.weekly = weeklyList;
};

// 减少秒杀时间
export const REDUCE_SECKILLS_TIME = state => {
  state.seckills.deadline.seconds--;
  if (state.seckills.deadline.seconds === -1) {
    state.seckills.deadline.seconds = 59;
    state.seckills.deadline.minute--;
    if (state.seckills.deadline.minute === -1) {
      state.seckills.deadline.minute = 59;
      state.seckills.deadline.hour--;
    }
  }
};
// 减少每周特价秒杀时间
export const REDUCE_WEEKLY_SPECIAL_TIME = state => {
  state.weekSpecial.weeklyDeadline.seconds--;
  if (state.weekSpecial.weeklyDeadline.seconds === -1) {
    state.weekSpecial.weeklyDeadline.seconds = 59;
    state.weekSpecial.weeklyDeadline.minute--;
    if (state.weekSpecial.weeklyDeadline.minute === -1) {
      state.weekSpecial.weeklyDeadline.minute = 59;
      state.weekSpecial.weeklyDeadline.hours--;
    }
  }
};

// 设置商品列表(搜索)
export const SET_GOODS_LIST = (state, data) => {
  state.goodsList = data.goodsList;
  state.asItems = data.asItems;
};

// 设置商品列表排序
export const SET_GOODS_ORDER_BY = (state, data) => {
  state.orderBy = data;
};

// 设置商品详细信息
export const SET_GOODS_INFO = (state, data) => {
  state.goodsInfo = data;
};

// // 添加购物车
export const new_customer_set = (state, data) => {
  state.new_customer = data
};

// 我的收藏添加购物车
export const ADD_SHOPPING_CART = (state, data) => {
  if (Array.isArray(data)) {
    data.forEach((item) => {
      let items = {
        goods_id: item.goods_id,
        count: item.count,
        img: item.package.img,
        package: item.package.intro,
        price: item.package.price,
        title: item.title
      };
      state.shoppingCart.push(items);
      state.newShoppingCart = item;
      if (state.shoppingCart && state.shoppingCart.general)
        state.shoppingCart.general.push(item);
      state.newShoppingCart = item;
    })
  } else {
    const item = {
      goods_id: data.goods_id,
      count: data.count,
      img: data.package.img,
      package: data.package.intro,
      price: data.package.price,
      title: data.title
    };
    state.shoppingCart.push(item);
    state.newShoppingCart = data;
    if (state.shoppingCart && state.shoppingCart.general)
      state.shoppingCart.general.push(data);
    state.newShoppingCart = data;
  }
};


// 设置购物车信息
export const setLineData = (state, data) => {
  state.line = data;
};


// 设置购物车信息
export const SET_SHOPPING_CART = (state, data) => {
  state.shoppingCart = data;
};

// 设置推荐信息
export const SET_RECOMMEND_INFO = (state, data) => {
  state.recommend = data;
};

// 设置收获地址
export const SET_USER_ADDRESS = (state, data) => {
  state.address = data;
};

// 设置结算步骤
export const SET_PAY_STEP = (state, step) => {
  state.PayStep = step;
};

// 设置navbar
export const SET_NAV_DATA = (state, data) => {
  state.navData = data;
  local.set("nav", JSON.stringify(data));
};
// 设置当前激活状态的nav
export const SET_CURRENT_NAV = (state, data) => {
  state.curNav = data;
  local.set("curNav", data);
};

//积分商城
export const SET_INTEG_LIST = (state, newList) => {
  state.indexList = newList;
}
//积分详情
export const SET_INTEG_DETAILS = (state, newDetails) => {
  state.integral = newDetails;
}



// WEBPACK FOOTER //
// ./src/vuex/mutations.js